<template>
  <b-card>
    <b-card-body class="p-0">
      <div>
        <b-img class="mb-3" center :src="mainlogo" alt="Center image" width="150px" max-height="50px"></b-img>
      </div>
      <p>
        If you use QuickBooks Online, AMS will be able to import your data (customers and vendors, invoices and
        payments)
        from your QuickBooks account. You need to authorize connection to your QuickBooks Online account.
      </p>


      <b-row align-h="end">
        <b-col cols="2"><b-badge :variant="is_connected ? 'success' : 'danger'">{{
          is_connected ? "Connected" : "Disconnected"
            }}</b-badge></b-col>
      </b-row>

      <b-form>
        <b-form-group id="realmId-group" label-cols-sm="4" label-cols-lg="3" content-cols-sm content-cols-lg="7"
          label="Realm ID" label-for="realmId">
          <b-form-input id="realmId" :readonly="true" v-model="form.realmId" trim></b-form-input>
        </b-form-group>

        <b-button id="connect-btn" class="px-3 mx-2" size="fw" variant="outline-primary"
          @click="submitQuery(commands.authUri)" v-if="!is_connected || loadingId == commands.authUri">
          <b-spinner v-if="loadingId == commands.authUri" small></b-spinner>
          Connect
          <b-img right :src="btnlogo" alt="img" width="50px" height="20px"></b-img>
        </b-button>

        <b-button id="disconnect-btn" class="px-3 mx-2" size="fw" variant="outline-danger"
          @click="submitQuery(commands.disconnect)" :disabled="loadingId == commands.disconnect" v-if="is_connected">
          <b-spinner v-if="loadingId == commands.disconnect" small></b-spinner>
          Disconnect
          <b-img right :src="btnlogo" alt="img" width="50px" height="20px"></b-img>
        </b-button>

        <b-button id="get-info-btn" class="px-3 mx-2" size="fw" variant="outline-success"
          @click="submitQuery(commands.getCompanyInfo)" :disabled="loadingId == commands.getCompanyInfo"
          v-if="is_connected">
          <b-spinner v-if="loadingId == commands.getCompanyInfo" small></b-spinner>
          Get Info
          <b-img right :src="btnlogo" alt="img" width="50px" height="20px"></b-img>
        </b-button>

        <b-button id="get-info-btn" class="px-3 mx-2" size="fw" variant="outline-success"
          @click="submitQuery(commands.downloadExcel)" :disabled="loadingId == commands.downloadExcel"
          v-if="is_connected">
          <b-spinner v-if="loadingId == commands.downloadExcel" small></b-spinner>
          Download Excel
          <b-img right :src="btnlogo" alt="img" width="50px" height="20px"></b-img>
        </b-button>
      </b-form>
      <div class="mt-6">
        <h6>{{ dataTitle }}</h6>
        <pre v-html="htmldata"></pre>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
///import axios from "axios";
import { mapState } from "vuex";
import mainlogo from "../assets/images/quickbook/quickbook_logo2.png"
import btnlogo from "../assets/images/quickbook/quickbook_btn_logo.png"

export default {
  data() {
    return {
      dataTitle: "",
      htmldata: "",
      token: null,
      is_establishing: false,
      form: {
        realmId: null,
      },
      checkEstablishedhandle: null,
      establishedCount: 0,
      mainlogo,
      btnlogo
    };
  },

  computed: {
    ...mapState("quickbook", [
      "loadingId",
      "commands",
      "authUri_data",
      "callback_data",
      "getRealm_data",
      "getHost_data",
      "refreshAccessToken_data",
      "getInvoiceByNumber_data",
      "getDueInvoices_data",
      "getInvoicesByUpdateRange_data",
      "createInvoice_data",
      "getCompanyInfo_data",
      "downloadExcel_data",
      "disconnect_data",
    ]),

    is_connected() {
      return !!this.token;
    },
  },

  watch: {
    getInvoicesByUpdateRange_data: function (val) {
      const json = this.parseJsonData(val)
      const { QueryResponse } = JSON.parse(json);
      this.htmldata = JSON.stringify(QueryResponse, null, 4);
      this.dataTitle = "Invoices Last 30 days";
    },
    getCompanyInfo_data: function (val) {
      const json = this.parseJsonData(val)
      this.htmldata = JSON.stringify(json, null, 4);
      this.dataTitle = "Company Info";
    },
    downloadExcel_data: function (val) {
      this.htmldata = `<a href="${val}" target="_blank">Download</a>`;
      this.dataTitle = "Download Excel";
    },
    disconnect_data: function () {
      this.token = null;
      this.is_establishing = false;
    },
    getRealm_data: function (val) {
      if (!val) return;
      const json = this.parseJsonData(val)
      const { realmId, token } = JSON.parse(json);
      this.token = token;
      this.form.realmId = realmId;
    },
    getHost_data: function (val) {
      if (!val) return;
      const json = this.parseJsonData(val)
      const { realmId, token } = json;
      this.token = token;
      this.form.realmId = realmId;

    },
    authUri_data: async function (url) {
      if (!url) {
        console.error('URL is required');
        return;
      }
      console.log("authUri", url);
      // Launch Popup using the JS window Object    
      url = this.parseUrl(url);

      console.log('authUri', url);
      this.openWindow(url, '');

      this.establishedCount = 0;
      this.is_establishing = true;

    },
    is_establishing: function (val) {
      if (val) {
        this.checkEstablishedhandle = setInterval(() => { this.checkHost() }, 1000);
      } else {
        window.clearInterval(this.checkEstablishedhandle);
      }
    },
    is_connected: function (val) {
      val && window.clearInterval(this.checkEstablishedhandle);
    },
    establishedCount: function (val) {
      val > 50 && window.clearInterval(this.checkEstablishedhandle);
    }
  },


  mounted() {
    this.checkHost()
  },

  methods: {
    parseJsonData(val) {
      if (typeof val == 'string') {
        return JSON.parse(val);
      } else
        return val;
    },

    // Helper function to open a new window with the given URL and parameters
    openWindow(url, parameters) {
      const left = (screen.width - 800) / 2;
      const top = (screen.height - 800) / 2;
      const fullParameters = `location=1,width=800,height=800,left=${left},top=${top}${parameters ? (',' + parameters) : ''}`;
      return window.open(url, '_blank', fullParameters);
    },

    handleOAuthRedirect(newWindow) {
      return new Promise((resolve, reject) => {
        const timer = setInterval(() => {
          try {
            const url = newWindow.location.href;
            if (url.indexOf('code') >= 0) {
              clearInterval(timer);
              newWindow.close();
              resolve(url);
            }
          } catch (e) {
            reject(e);
          }
        }, 100);
      });
    }
    ,

    checkHost() {
      this.establishedCount++
      this.submitQuery(this.commands.getHost)
    },


    parseUrl(url) {
      const httpsAppend = "https://";
      return `${httpsAppend}${url.slice(httpsAppend.length)}`;
    },

    submitQuery(cmd) {
      this.dataTitle = "";
      this.htmldata = "";
      const ams_request = { ...this.form };
      if (cmd == this.commands.getRealm) {
        if (!this.form.realmId) {
          return;
        }
      }
      if (cmd == this.commands.getInvoicesByUpdateRange) {
        const thrityDays = 30 * 24 * 3600 * 1000 * 6;
        ams_request.endDateTime = new Date(Date.now()).toISOString();
        ams_request.startDateTime = new Date(
          Date.now() - thrityDays
        ).toISOString();
      }
      this.$store.dispatch("quickbook/queryQuickbook", {
        ams_request,
        cmd,
      });
    },
  },
};
</script>
